import BulletListToolbarView from "./BulletListToolbarView.vue";
import {BulletList as BulletListExtension} from "@tiptap/extension-bullet-list";
import {ListItem as ListItemExtension} from "@tiptap/extension-list-item";

export default class BulletList {

    constructor() {
        this.toolbarView = BulletListToolbarView;
    }

    static create() {
        return new BulletList();
    }

    getExtensions() {
        return [ListItemExtension, BulletListExtension];
    }
}